// src/api/cloudApi.js
import { createApiInstance } from './index';
import { getProjectContext, withProjectContext } from './projectContext';
const cloudApi = createApiInstance();

export const fetchCloudDashboard = async (payload = {}) => {
  const { project_uuid } = getProjectContext();
  if (!project_uuid) {
    throw new Error('找不到有效的 project_uuid，請先選擇專案');
  }
  const response = await cloudApi.post('cloud-dashboard/', withProjectContext(payload));
  return response.data;
};
